import type { LinkProps } from "@casino/legacy/client/shared/NextLink";
import CustomCarousel from "../../Carousel/CustomCarousel";
import Section from "../../PageSection/Section";
import Grid from "../../PageSection/SectionTitle/Grid";
import placeholderItems from "./helpers/placeholderItems";
import SeeAllLinkPlaceholder from "./SeeAllLinkPlaceholder";
import TitleIdPlaceholder from "./TitleIdPlaceholder";

type Props = {
  width?: number;
  height?: number;
  length?: number;
  items?: React.JSX.Element[];
  rtp?: boolean;
  href?: LinkProps["href"];
  titleId?: string;
  reelClassName?: string;
};

const CarouselPlaceholder: FC<Props> = ({
  length,
  width,
  height,
  href,
  items,
  rtp,
  titleId,
  reelClassName,
}) => {
  const carouselItems =
    items ??
    placeholderItems({
      width: width ?? 164,
      height: height ?? 124,
      length: length ?? 8,
      showGameInfo: false,
      rtp,
    });

  return (
    <Section>
      <div className="flex flex-col gap-5">
        <Grid>
          <TitleIdPlaceholder titleId={titleId} href={href} />
          <SeeAllLinkPlaceholder href={href} />
        </Grid>
      </div>
      <CustomCarousel items={carouselItems} reelClassName={reelClassName} />
    </Section>
  );
};

export default CarouselPlaceholder;
